import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ApplicationState {
  data: any;
}

const initialState: ApplicationState = {
  data: null,
};

const memberSlice = createSlice({
  name: "member",
  initialState,
  reducers: {
    setData(state, action: PayloadAction<any>) {
      state.data = action.payload;
    },
    resetData(state) {
      state.data = null;
    },
  },
});

export const { setData, resetData } = memberSlice.actions;
export default memberSlice.reducer;
